import { render, staticRenderFns } from "./duplicate-client-profile-modal.vue?vue&type=template&id=0304ff12"
import script from "./duplicate-client-profile-modal.vue?vue&type=script&lang=js"
export * from "./duplicate-client-profile-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports